// ============================================================
// FYUNOR — US Federal Income Tax
// 2026 brackets, standard deduction, and progressive tax calc.
// Update this file when the IRS releases new tax-year brackets.
// ============================================================

import { FILING_STATUS } from "./constants";

// --- 2026 Federal Tax Brackets ---
export const FEDERAL_BRACKETS = {
  [FILING_STATUS.SINGLE]: [
    { rate: 0.10, upTo: 12400 },
    { rate: 0.12, upTo: 50400 },
    { rate: 0.22, upTo: 105700 },
    { rate: 0.24, upTo: 201775 },
    { rate: 0.32, upTo: 256225 },
    { rate: 0.35, upTo: 640600 },
    { rate: 0.37, upTo: Infinity },
  ],
  [FILING_STATUS.MARRIED_JOINTLY]: [
    { rate: 0.10, upTo: 24800 },
    { rate: 0.12, upTo: 100800 },
    { rate: 0.22, upTo: 211400 },
    { rate: 0.24, upTo: 403550 },
    { rate: 0.32, upTo: 512450 },
    { rate: 0.35, upTo: 768700 },
    { rate: 0.37, upTo: Infinity },
  ],
  [FILING_STATUS.MARRIED_SEPARATELY]: [
    { rate: 0.10, upTo: 12400 },
    { rate: 0.12, upTo: 50400 },
    { rate: 0.22, upTo: 105700 },
    { rate: 0.24, upTo: 201775 },
    { rate: 0.32, upTo: 256225 },
    { rate: 0.35, upTo: 384350 },
    { rate: 0.37, upTo: Infinity },
  ],
  [FILING_STATUS.HEAD_OF_HOUSEHOLD]: [
    { rate: 0.10, upTo: 17700 },
    { rate: 0.12, upTo: 67450 },
    { rate: 0.22, upTo: 105700 },
    { rate: 0.24, upTo: 201750 },
    { rate: 0.32, upTo: 256200 },
    { rate: 0.35, upTo: 640600 },
    { rate: 0.37, upTo: Infinity },
  ],
};

// --- 2026 Standard Deduction ---
export const STANDARD_DEDUCTION = {
  [FILING_STATUS.SINGLE]: 16100,
  [FILING_STATUS.MARRIED_JOINTLY]: 32200,
  [FILING_STATUS.MARRIED_SEPARATELY]: 16100,
  [FILING_STATUS.HEAD_OF_HOUSEHOLD]: 24150,
};

// --- Helpers ---

/** Apply progressive brackets to a taxable income amount. */
export function calcProgressiveTax(taxableIncome, brackets) {
  let tax = 0;
  let prev = 0;
  for (const { rate, upTo } of brackets) {
    if (taxableIncome <= prev) break;
    const limit = upTo ?? Infinity;
    tax += (Math.min(taxableIncome, limit) - prev) * rate;
    prev = limit;
  }
  return tax;
}

/** Standard deduction for a filing status (falls back to single). */
export function getStandardDeduction(filingStatus) {
  return STANDARD_DEDUCTION[filingStatus] ?? STANDARD_DEDUCTION[FILING_STATUS.SINGLE];
}

/** Federal income tax for a taxable income and filing status. */
export function calcFederalIncomeTax(taxableIncome, filingStatus) {
  const brackets = FEDERAL_BRACKETS[filingStatus] ?? FEDERAL_BRACKETS[FILING_STATUS.SINGLE];
  return calcProgressiveTax(Math.max(0, taxableIncome), brackets);
}